import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlarmTableRowComponent } from '@components/alarm-table-row/alarm-table-row.component';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Component({
    selector: 'app-dashboard-alarm-compact',
    templateUrl: './dashboard-alarm-compact.component.html',
    styleUrls: ['./dashboard-alarm-compact.component.scss'],
    standalone: false
})
export class DashboardAlarmCompact extends AlarmTableRowComponent {
    @Output() onSetPage = new EventEmitter();
    @Input() currentPage: number;
    @Input() pages: number;

    onPrevious() {
        this.onSetPage.emit(Math.max(this.currentPage - 1, 0));
    }

    onNext() {
        this.onSetPage.emit(Math.min(this.currentPage + 1, this.pages - 1));
    }

    shouldDisableButton(alarm: AlarmMonitoring): boolean {
        return (
            !alarm.UnAck ||
            this.alarmMonitoringService.isAckInProgress(alarm) ||
            this.alarmMonitoringService.isBuzzerActive()
        );
    }

    ackAlarm(alarm) {
        this.alarmMonitoringService.ackAlarm(alarm);
    }
}
